import { setPlayVideoEvent, submitFetch } from './common'
import Cookies from 'js-cookie'
import edjsHTML from "editorjs-html"
import { nl2br } from '@/js/utils/format'
import SmoothScroll from 'smooth-scroll'

const linkButtonBlock = (block) => {
    let targetAttr = ''
    if(block.data.target){
        targetAttr = `target="${block.data.target}"`
    }
    return `<a class="link-button" href="${block.data.url}" ${targetAttr}>${block.data.name}</a>`;
}

const imageBlock = (block) => {
    const figClassList = []
    const imgClassList = []
    if(block.data.withBorder){
        figClassList.push('ejs-border')
    }
    if(block.data.withBackground){
        figClassList.push('ejs-background')
    }
    if(block.data.stretched){
        imgClassList.push('ejs-stretched')
    }

    return `
    <figure class="${figClassList.join(' ')}">
        <img src="${block.data.file.url}" alt="${block.data.caption}" class="${imgClassList.join(' ')}" />
    ${block.data.caption ? `<figcaption>${block.data.caption}</figcaption>` : ''}
    </figure>`;
}


const loadBody = async (id) => {
    const res = await submitFetch(`/api/product/${id}`, 'GET', {
        columns: ['description']
    })

    if (res.description.match(/^\{/)) {
        // editorJSの記事の場合
        const edjsParser = edjsHTML({
            linkButton: linkButtonBlock,
            image: imageBlock,
        })

        const content = JSON.parse(res.description)
        content.blocks = content.blocks.map(_val => {
            if (_val.type === 'image') {
                _val.data.file.url = '/thumb/path/product_body/' + _val.data.file.url
            }
            return _val
        })

        return edjsParser.parse(content).join('')
    } else {
        // 標準テキストの場合
        return `<h2>COMMENT</h2><p>${nl2br(res.description)}</p>`
    }
}

const createToc = (body) => {
    const descEl = document.querySelector('.description')

    if(descEl.querySelectorAll('h2').length){
        const tocEl = document.createElement('div')
        tocEl.id = 'toc'
        tocEl.innerHTML = '<ul></ul>'
        descEl.parentNode.insertBefore(tocEl, descEl);

        descEl.querySelectorAll('h2').forEach((el, i) => {
            console.log(el)
            el.id = `toc-${i}`
            const li = document.createElement('li')
            li.innerHTML = `<a href="#toc-${i}">${el.innerText}</a>`
            document.querySelector('#toc ul').appendChild(li)
        })
    }
}

const main = async () => {
    if (!document.querySelector('#page-product')) return

    const id = location.pathname.replace(/^.*?\/?(\d+)?(\/edit)?$/, '$1')
    const body = await loadBody(id)

    document.querySelector('.description').innerHTML = body

    createToc(body)
    document.querySelector('#video video').addEventListener('play', e => {
        //(!!e.currentTarget.webkitEnterFullscreen) && e.currentTarget.webkitEnterFullscreen();
        if (!Cookies.get('_vcnt')) {
            Cookies.set('_vcnt', 1, { expires: 1 / 24 })
            // send analytics
            setPlayVideoEvent(location.pathname)
            let id = location.pathname.replace(/^.*?([0-9]+)$/, "$1")
            submitFetch(`/api/product/viewcount/${id}`, 'POST')
        }
    })
    SmoothScroll('a[href*="#"]');
}

export default main